'use strict';

var _react = _interopRequireWildcard(require('react'));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== 'function') return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (
    obj === null ||
    (_typeof(obj) !== 'object' && typeof obj !== 'function')
  ) {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor =
    Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor
        ? Object.getOwnPropertyDescriptor(obj, key)
        : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj['default'] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }
  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf(o, p);
}

var wistiaResponsivePaddingStyles = {
  padding: '56.25% 0 0 0',
  position: 'relative',
};
var wistiaResponsiveWrapperStyles = {
  height: '100%',
  left: '0',
  position: 'absolute',
  top: '0',
  width: '100%',
};
var wistiaEmbedStyles = {
  height: '100%',
  position: 'relative',
  width: '100%',
};
var wistiaSwatchStyles = {
  height: '100%',
  left: '0',
  opacity: '0',
  overflow: 'hidden',
  position: 'absolute',
  top: '0',
  transition: 'opacity 200ms',
  width: '100%',
};
var wistiaImgStyles = {
  filter: 'blur(5px)',
  height: '100%',
  objectFit: 'contain',
  width: '100%',
};

var WistiaVideoEmbed =
  /*#__PURE__*/
  (function (_Component) {
    _inherits(WistiaVideoEmbed, _Component);

    function WistiaVideoEmbed(props) {
      _classCallCheck(this, WistiaVideoEmbed);

      return _possibleConstructorReturn(
        this,
        _getPrototypeOf(WistiaVideoEmbed).call(this, props)
      );
    }

    _createClass(WistiaVideoEmbed, [
      {
        key: 'componentWillMount',
        value: function componentWillMount() {
          if (typeof document !== 'undefined') {
            var script1 = document.createElement('script');
            var script2 = document.createElement('script');
            script1.src =
              'https://fast.wistia.com/embed/medias/' +
              this.props.wistiaID +
              '.jsonp';
            script1.async = true;
            script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
            script2.async = true;
            document.body.appendChild(script1);
            document.body.appendChild(script2);
          }
        },
      },
      {
        key: 'render',
        value: function render() {
          return _react['default'].createElement(
            'div',
            {
              className: 'wistia_responsive_padding',
              style: wistiaResponsivePaddingStyles,
            },
            _react['default'].createElement(
              'div',
              {
                className: 'wistia_responsive_wrapper',
                style: wistiaResponsiveWrapperStyles,
              },
              _react['default'].createElement(
                'div',
                {
                  className:
                    'wistia_embed wistia_async_' +
                    this.props.wistiaID +
                    ' videoFoam=true ' +
                    this.props.wistiaOptions,
                  style: wistiaEmbedStyles,
                },
                _react['default'].createElement(
                  'div',
                  {
                    className: 'wistia_swatch',
                    style: wistiaSwatchStyles,
                  },
                  _react['default'].createElement('img', {
                    alt: this.props.altText ? this.props.altText : 'Video',
                    src:
                      'https://fast.wistia.com/embed/medias/' +
                      this.props.wistiaID +
                      '/swatch',
                    style: wistiaImgStyles,
                  })
                )
              )
            )
          );
        },
      },
    ]);

    return WistiaVideoEmbed;
  })(_react.Component);

export default WistiaVideoEmbed;
